<template>
  <div :class="{ 'table-row': true, open: isOpen }">
    <div @click="$emit('toggleLead', lead.LEADID)" class="dropdown-chevron leads-cell"><img src="../assets/chevron.svg" /></div>
    <div @click="$emit('toggleLead', lead.LEADID)" class="leads-cell" style="cursor: pointer">
      <img v-if="lead.COMPANYID" src="../assets/company.svg" />
      <img v-else-if="lead.CONTACTID" src="../assets/individual.svg" />
      <img v-else src="../assets/unlinked-contact.svg" />
    </div>
    <div class="lead-name leads-cell" @click="$emit('toggleLead', lead.LEADID)">
      {{ getLeadName(lead) }}
      <img v-if="isOpen && (lead.CONTACTID || lead.COMPANYID)" @click.stop="navigateToContact()" src="../assets/external-link.svg" />
    </div>
    <div class="leads-cell">{{ formatDate(lead.CREATEDATE) }}</div>
    <div class="leads-cell score-cell">
      <ScoreSelector :lead="lead" />
    </div>
    <div
      :class="{ 'leads-cell': true, 'last-activity': true, 'high-alert': lead.lastActivityAlert && !lead.COMPLETE, new: getLastActivity(lead) == 'New' }"
      @click="getLastActivity(lead) ? $emit('showDelayAlert', lead.LEADID) : null">
      <span>{{ getLastActivity(lead) }}</span>
      <img src="../assets/activity-alert.svg" />
    </div>
    <div class="leads-cell">{{ lead.SOURCE }}</div>
    <div :class="{ 'lead-status-arrow': true, 'leads-cell': true, green: getSalesperson(lead.ASSIGNEDID), blue: !getSalesperson(lead.ASSIGNEDID) }">
      <div @click="user.leadsAdmin ? $emit('showAssignSalesperson', lead.LEADID) : null" :class="{ 'no-hover': !user.leadsAdmin }">
        <p class="main">{{ getSalesperson(lead.ASSIGNEDID) }}</p>
        <p class="action">{{ getSalesperson(lead.ASSIGNEDID) ? 'Change' : 'Select' }}</p>
        <img id="greenArrow" src="../assets/green-arrow-transition.svg" />
        <img id="blueArrow" src="../assets/blue-arrow-transition.svg" />
        <img id="grayArrow" src="../assets/gray-arrow-transition.svg" />
      </div>
    </div>
    <div :class="{ 'lead-status-arrow': true, 'leads-cell': true, 'match-previous': true, green: lead.company || lead.contact, blue: getSalesperson(lead.ASSIGNEDID) && !lead.company && !lead.contact }">
      <div @click="contactLinkAction()" :class="{ 'no-hover': shouldHideUnlinkContact() }">
        <p class="main">{{ lead.LINKMETHOD }}</p>
        <p class="action">{{ lead.company || lead.contact ? 'Unlink' : 'Select' }}</p>
        <img id="greenArrow" src="../assets/green-arrow-transition.svg" />
        <img id="blueArrow" src="../assets/blue-arrow-transition.svg" />
        <img id="grayArrow" src="../assets/gray-arrow-transition.svg" />
      </div>
    </div>
    <div :class="{ 'lead-status-arrow': true, 'leads-cell': true, 'match-previous': true, green: lead.interactions.length, blue: (lead.company || lead.contact) && !lead.interactions.length }">
      <div @click="lead.company || lead.contact || lead.interactions.length ? $emit('showAddInteraction', lead.LEADID) : null">
        <p class="main">{{ getLastInteraction(lead.interactions) }}</p>
        <p class="action">{{ lead.interactions.length ? 'Add' : 'Select' }}</p>
        <img id="greenArrow" src="../assets/green-arrow-transition.svg" />
        <img id="blueArrow" src="../assets/blue-arrow-transition.svg" />
        <img id="grayArrow" src="../assets/gray-arrow-transition.svg" />
      </div>
    </div>
    <div :class="{ 'lead-status-arrow': true, 'leads-cell': true, 'match-previous': true, green: lead.COMPLETE, blue: lead.interactions.length && !lead.COMPLETE }">
      <div @click="!lead.COMPLETE && lead.interactions.length ? $emit('showAddCompletion', lead.LEADID) : lead.COMPLETE ? $emit('showUncompleteConfirmation', lead.LEADID) : null">
        <p class="main">{{ formatDate(lead.COMPLETEDATE) }}</p>
        <p class="action">{{ lead.COMPLETE ? 'Uncomplete' : 'Select' }}</p>
        <img id="greenArrow" src="../assets/green-arrow-transition.svg" />
        <img id="blueArrow" src="../assets/blue-arrow-transition.svg" />
        <img id="grayArrow" src="../assets/gray-arrow-transition.svg" />
      </div>
    </div>
    <div class="leads-cell inv-cell">
      <span v-if="lead.COMPLETE">{{ lead.INVNUM }}</span>
    </div>
    <div class="leads-cell">
      <span v-if="!lead.COMPLETE || leadCompletionType() == 'Confirmed Order'">{{ lead.AMOUNT ? `$${lead.AMOUNT}` : '' }}</span>
    </div>
    <div class="leads-cell lead-function-icons">
      <img v-if="isOpen" @click="$emit('toggleLead', lead.LEADID)" src="../assets/close.svg" />
      <div class="context-menu" @click="!showContextMenu ? (showContextMenu = true) : null" v-click-outside="() => (showContextMenu = false)">
        <img id="hover" src="../assets/three-dots-menu-hover.svg" />
        <img id="noHover" src="../assets/three-dots-menu.svg" />
        <div class="context-dropdown" v-if="showContextMenu">
          <div
            v-if="!lead.company"
            class="context-dropdown-item"
            @click="
              $emit('showSendEmail', 'touchpoint1');
              showContextMenu = false;
            ">
            <img src="../assets/email.svg" />Email Touchpoint 1
          </div>
          <div
            v-if="!lead.company"
            class="context-dropdown-item"
            @click="
              $emit('showSendEmail', 'touchpoint2');
              showContextMenu = false;
            ">
            <img src="../assets/email.svg" />Email Touchpoint 2
          </div>
          <div
            v-if="!lead.company"
            class="context-dropdown-item"
            @click="
              $emit('showSendEmail', 'touchpoint3');
              showContextMenu = false;
            ">
            <img src="../assets/email.svg" />Email Touchpoint 3
          </div>
          <div
            v-if="!lead.company"
            class="context-dropdown-item"
            @click="
              $emit('showSendEmail', 'touchpoint4');
              showContextMenu = false;
            ">
            <img src="../assets/email.svg" />Email Touchpoint 4
          </div>
          <div
            v-if="!lead.company"
            class="context-dropdown-item"
            @click="
              $emit('showSendContractorList', lead);
              showContextMenu = false;
            ">
            <img src="../assets/contractor.svg" />Email Contractor List
          </div>
          <div
            class="context-dropdown-item"
            @click="
              $emit('showMarkAsDead', lead.LEADID);
              showContextMenu = false;
            ">
            <img src="../assets/skull.svg" />Mark as Dead
          </div>
          <div class="context-dropdown-item section-divider" v-if="(user.userid == lead.ASSIGNEDID && !lead.NAME) || user.leadsAdmin" @click="$emit('showDeleteConfirmation', lead.LEADID)">
            <img src="../assets/trash.svg" />Delete
          </div>
        </div>
      </div>
    </div>
    <Lead v-if="isOpen" :leadid="lead.LEADID" @closeLead="$emit('toggleLead', lead.LEADID)" />
  </div>
</template>

<script>
import Lead from '@/components/Lead.vue';
import ScoreSelector from '@/components/ScoreSelector.vue';
import useCurrentUser from '@/composables/useCurrentUser';
import useUsersQuery from '@/composables/useUsersQuery';
import SendEmail from '@/components/SendEmail.vue';
import { getLastActivity } from '@/composables/useGetLastActivity';

export default {
  name: 'LeadHeader',
  components: {
    Lead,
    ScoreSelector,
    SendEmail,
  },
  props: {
    lead: {
      type: Object,
      required: true,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'toggleLead',
    'showAssignSalesperson',
    'showAddInteraction',
    'showAddCompletion',
    'showDeleteConfirmation',
    'showUncompleteConfirmation',
    'showDelayAlert',
    'showUnlinkConfirmation',
    'showSendEmail',
    'showSendContractorList',
    'showLinkContact',
    'showMarkAsDead',
  ],
  setup() {
    const { user } = useCurrentUser();
    const { allUsers } = useUsersQuery();

    return { user, allUsers, getLastActivity };
  },
  data() {
    return {
      showContextMenu: false,
      showSendEmail: null,
    };
  },
  methods: {
    getLeadName(lead) {
      if (lead.company) {
        return lead.company.NAME;
      } else if (lead.contact) {
        return `${lead.contact.FIRSTNAME} ${lead.contact.LASTNAME}`;
      } else {
        return lead.NAME || '';
      }
    },
    formatDate(date) {
      if (!date) return '';
      const dateObj = new Date(parseInt(date));
      return `${dateObj.getMonth() + 1}/${dateObj.getDate()}/${dateObj.getFullYear()}`;
    },
    getSalesperson(id) {
      return this.allUsers.find((salesperson) => salesperson.USERID === id)?.DISPLAYNAME;
    },
    getLastInteraction(interactions) {
      if (interactions.length == 0) return '';

      const sortedInteractions = interactions.sort((a, b) => {
        return b.DATE - a.DATE;
      });

      return sortedInteractions[0].TYPE;
    },
    shouldHideUnlinkContact() {
      if (!this.lead.company && !this.lead.contact) return true;
      if (!this.lead.NAME) return true;
      if (this.user.userid == this.lead.ASSIGNEDID) return false;
      if (this.user.leadsAdmin) return false;
      return true;
    },
    leadCompletionType() {
      if (!this.lead.COMPLETE) return 'In Progress';
      if (this.lead.interactions.some((interaction) => interaction.TYPE == 'Confirmed Order')) return 'Confirmed Order';
      return 'Completed';
    },
    navigateToContact() {
      if (this.lead.CONTACTID) {
        this.$router.push({ name: 'contacts', params: { contactid: this.lead.CONTACTID } });
      } else if (this.lead.COMPANYID) {
        this.$router.push({ name: 'companies', params: { companyid: this.lead.COMPANYID } });
      }
    },
    contactLinkAction() {
      if (this.lead.ASSIGNEDID == null) {
        return;
      } else if (!this.lead.company && !this.lead.contact) {
        this.$emit('showLinkContact', this.lead.LEADID);
      } else if (!this.shouldHideUnlinkContact()) {
        this.$emit('showUnlinkConfirmation', this.lead.LEADID);
      }
    },
  },
};
</script>
